import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { analyticsClickEvent } from '../../action/firebaseAnalytics/firebaseAnalytics';
import { getAllUserNotification, updateNotificationStatus } from '../../action/notification/notification';
import parse from 'html-react-parser';
import { PropTypes } from 'prop-types';
import NotificationContent from './NotificationContent';
import {getSessionIdFromStorage, getUserContext} from "../../utils/helpers/storageUtils";



class Notification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            notifications: [],
            timeout: null,
            dataStoreNotifications: props.notificationDatas
        }
    }

    componentWillReceiveProps(nextProps) {
      
        if(nextProps.notificationDatas!=this.state.notifications){
            this.setState({ notifications: nextProps.notificationDatas });
            if(nextProps.notificationDatas){
                let totalNotificationResult=nextProps.notificationDatas.filter(e => e.read_status === false);
                this.props.totalNotification(totalNotificationResult.length)
            }
        }
    }

    componentDidMount() {
        if (localStorage.getItem('fromWhere') != 'skip') {
            this.initialLoad()
            .catch(error => console.error(error));
            this.setState({
                timeout: setInterval(() => {
                    this.initialLoad()
                    .catch(error => console.error(error));
                }, 1800000)
            });
        }

    }

    initialLoad = async () => {
        let notificationData = [];
        let sessionId = getSessionIdFromStorage();
        if(sessionId) {
            const notification = await getAllUserNotification(getUserContext());
            console.log(notification);
            if (notification !== undefined) {
                if (notification.data.statusCode === 200) {
                    let unReadNotificationCount = 0;
                    notification.data.data.map((data) => {
                        if (data.read_status === false) {
                            unReadNotificationCount += 1;
                        }
                        
                        notificationData.push(data);
                    
                });


                this.setState({ notifications: notificationData });

                this.props.totalNotification(unReadNotificationCount,notificationData.length)
                }
            }
        }
        clearInterval(this.state.timeout);
        this.setState((prevState) => {
            return { timeout: null }
        })
    }

    updateNotification = async (e, notificationID) => {
        let params = { notification_id: notificationID };
        let sessionId = getSessionIdFromStorage();
        if(sessionId) {
            let notificationStatusUpdate = await updateNotificationStatus(params);
            if (notificationStatusUpdate !== undefined) {
                if (notificationStatusUpdate.data.statusCode === 200) {
                    analyticsClickEvent('notification_readed','')
                    this.props.notCloseNotification(e)
                    e.preventDefault();
                    this.initialLoad()
                    .catch(error => console.error(error));
                };
            }
        }
    }

    handleLinkClick = async(e, url, notificationID) => {
        e.preventDefault();       
        this.updateNotification(e, notificationID);
        setTimeout(() => {
            window.open(url, '_blank', 'noopener, noreferrer');
        }, 400); 
    };

    displayNotification = () => {
        return <span>
            {this.state.notifications.map((response, index) =>

                    <div className="d-flex" key={response.title}>
                        <div className="tick-mark-item">
                            <img src="images/tickmark.png" alt="tick" />
                        </div>
                        <div className="notification-content">
                            <h3>{response.title}</h3>
                            <h6 className="notification-sub-title">{response.sub_title}</h6>
                            {response.message!=null && response.message!='' && response.message!=undefined &&
                            <p>
                                <NotificationContent message={response.message} notificationID={response.notification_id} handleLinkClick={this.handleLinkClick} />
                            </p>
                            }
                        </div>
                        <div className="notification-time">
                            <span className="time-msg">{moment(response.created_date).fromNow()}</span>

                        <span className={ response.read_status === false ? "active": ''}> </span>
                    </div>
                    {!response.read_status &&
                       <div className="notification-close">
                           <button
                               className="notification-button"
                               onKeyDown={(e) => e.preventDefault()}
                               onClick={(e) => {
                                   this.updateNotification(e, response.notification_id).catch(error => console.error(error));
                               }}
                               aria-label="Close notification"
                           >
                               <img src="images/close.png" className="default" alt="Close notification" />
                           </button>
                       </div>
                    }
                </div>

                // </Link>
            )
            }
        </span>
    }

    render() {
        return (
            <div>
                {this.displayNotification()}

            </div>



        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    };
};
 
  export const mapStateToProps = (state) => {
    return {
        notificationDatas: state.dataStore.notificationDatas
    };
  };

Notification.propTypes = {
    notificationDatas: PropTypes.array,
    notCloseNotification: PropTypes.func,
    totalNotification: PropTypes.func
}

export default connect(mapStateToProps,mapDispatchToProps,null,{forwardRef: true})(Notification);
  


